export const environment = {
  production: true,
  app_env: 'staging',
  client_url: 'https://dev-client-api.instaveritas.com/client-api/',
  crm_url: 'https://staging.instaveritas.com/',
  api_url: 'https://staging.instaveritas.com/api',
  url: 'https://client.instaveritas.com/',
  sentry_dns: 'https://f47c5da536c44b77b093f1e718093bd9@o439184.ingest.sentry.io/5429657',
};



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/environments/environment.ts